'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * [是否存在参数]
 * @param  {[type]} path [路径]
 * @return {[type]}      [是否存在参数]
 */
function existsParamsInPath(path) {
    return (/,/.test(path)
    );
}

/**
 * [解析路径]
 * @param  {[type]} path [路径]
 * @return {[type]}      [路径+参数数组]
 */
function parsePath(path) {
    if (!path) return;
    if (path.indexOf(',') == -1) {
        return {
            path: path.replace(/\s/g, '')
        };
    } else {
        var segments = path.split(","),
            vars = segments.slice(1);
        return {
            path: segments[0].replace(/\s/g, ''),
            vars: vars.map(function (o) {
                return o.replace(/\s/g, '');
            })
        };
    }
}

function findPathByEvent(e) {

    if (/^15\./.test(_react2.default.version)) {
        var loop = function loop(inst) {
            if (!inst) return '';
            var p = inst._currentElement && inst._currentElement._owner && inst._currentElement._owner._currentElement && inst._currentElement._owner._currentElement.props.path;

            if (!p && inst) return loop(inst._hostParent);

            return p;
        };
        return loop(e._targetInst);
    }

    if (/^16\./.test(_react2.default.version)) {
        var _loop = function _loop(inst) {
            if (!inst) return '';
            var p = inst.return && inst.return.memoizedProps && inst.return.memoizedProps.path;

            if (!p && inst) return _loop(inst.return);

            return p;
        };
        return _loop(e._targetInst);
    }
}

exports.default = {
    parsePath: _lodash2.default.memoize(parsePath),
    existsParamsInPath: existsParamsInPath,
    findPathByEvent: findPathByEvent
};
module.exports = exports['default'];